import React from 'react';
import dateFormat, { masks } from "dateformat";
class BookingsMasterDetailView2 extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {

    return (
    <div>
      <p className='col1'>FIRST REMINDER:</p><p className='col2'>{dateFormat(this.props.data.data.FIRST_REMINDER,"dd-mmm-yyyy")}</p>
      <p className='col1'>SECOND REMINDER:</p><p className='col2'>{dateFormat(this.props.data.data.SECOND_REMINDER,"dd-mmm-yyyy")}</p>
      <p className='col1'>CF NAME:</p><p className='col2'>{this.props.data.data.CF_NAME}</p>
      <p className='col1'>CF COMMENT:</p><p className='col2'>{this.props.data.data.CF_COMMENT}</p>
      <p className='col1'>NOTE:</p><p className='col2'>{this.props.data.data.NOTE}</p>
      </div>
    );
  }
}

export default BookingsMasterDetailView2;
